import { useNotificationTriggerDeliveriesQuery } from "generated/graphql";
import { useMemo } from "react";

export default function useGetNotificationTriggerDeliveries(triggerId: string, first = 50) {
  const { data, error, loading, refetch } = useNotificationTriggerDeliveriesQuery({
    variables: { triggerId, first },
  });

  const deliveries = useMemo(() => data?.notificationTriggerDeliveries ?? [], [data]);

  return { deliveries, error, loading, refetch } as const;
}
